import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { buildFooterJsonLd } from '@components/footer/utils';
import { ButtonComponent } from '@shared/components/button';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { HandleHtmlLinksDirective, LinkDirective } from '@shared/directives';
import { LanguageService } from '@shared/services/language';
import { SeoService } from '@shared/services/seo';
import { PageStore } from '@stores';

@Component({
  selector: 'app-footer',
  imports: [TitleComponent, ButtonComponent, LinkDirective, SvgComponent, NgTemplateOutlet, HandleHtmlLinksDirective],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  footerStore = inject(PageStore).footer;

  private readonly seoService = inject(SeoService);
  private readonly languageService = inject(LanguageService);

  constructor() {
    effect(() => {
      const footer = this.footerStore();
      if (footer) {
        const menuSchemaJsonLd = buildFooterJsonLd(this.languageService.instant('SCHEMA_JSON_LD.FOOTER_MENU'), footer);
        if (menuSchemaJsonLd) this.seoService.addJsonLdScript('footer-menu', menuSchemaJsonLd);
      }
    });
  }
}
